export default __webpack_public_path__ + "static/media/017-vest.96c6eddb.svg";